import React from "react";
import ReactDOM from "react-dom/client";
import "@/index.css";
import App from "@/App";

// Register PWA service worker (enables "Install app" prompt in Chrome/Edge).
// Auto-reloads the page silently when a new service worker takes control
// (after a deploy) and periodically polls for updates so the installed PWA
// always converges to the latest bundle without requiring a manual refresh.
const SW_UPDATE_INTERVAL_MS = 5 * 60 * 1000; // check every 5 min
if ("serviceWorker" in navigator) {
  window.addEventListener("load", () => {
    navigator.serviceWorker.register("/sw.js").then((reg) => {
      reg.addEventListener("updatefound", () => {
        const nw = reg.installing;
        if (!nw) return;
        nw.addEventListener("statechange", () => {
          if (nw.state === "installed" && navigator.serviceWorker.controller) {
            // A new bundle is waiting — activate it immediately.
            nw.postMessage?.({ type: "SKIP_WAITING" });
          }
        });
      });
      // Kick an update check every N minutes + whenever the app regains focus.
      setInterval(() => { reg.update().catch(() => {}); }, SW_UPDATE_INTERVAL_MS);
      document.addEventListener("visibilitychange", () => {
        if (document.visibilityState === "visible") reg.update().catch(() => {});
      });
    }).catch(() => {});
    let reloaded = false;
    navigator.serviceWorker.addEventListener("controllerchange", () => {
      if (reloaded) return;
      reloaded = true;
      window.location.reload();
    });
  });
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>,
);
